<template>
  <v-card flat class="mx-auto">
    <v-card-title>
      Get Your Quote
    </v-card-title>
    <v-card-text v-if="cart_empty">
      Add products to your cart to find out their trade-in value
    </v-card-text>
    <v-data-table
      v-else
      :headers="headers"
      :items="cart_items"
      class="elevation-1"
      hide-default-footer
      dense
    >
      <template v-slot:item.image="{ item }">
        <v-img :src="item.image" width="64"></v-img>
      </template>
      <template v-slot:item.title="{ item }">
        {{ item.title }}
        <p>
          <i> {{ item.description }} </i>
        </p>
      </template>
      <template v-slot:item.delete="{ item }">
        <v-btn icon small color="gray" @click="remove_item(item)">
          <v-icon dark>mdi-delete</v-icon>
        </v-btn>
      </template>
    </v-data-table>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn outlined small color="red" @click="$store.commit('clear_cart')">
        Clear All
      </v-btn>
    </v-card-actions>
    <v-card-text>
      <p>Please enter your name and email to view your quote.</p>
      <p>
        You will also receive an email with instructions on how to “submit” your
        clubs.
      </p>
    </v-card-text>
    <form>
      <v-text-field
        v-model="name"
        :error-messages="nameErrors"
        :counter="100"
        label="Name"
        required
        @input="$v.name.$touch()"
        @blur="$v.name.$touch()"
      ></v-text-field>
      <v-text-field
        v-model="email"
        :error-messages="emailErrors"
        label="E-mail"
        required
        @input="$v.email.$touch()"
        @blur="$v.email.$touch()"
      ></v-text-field>
    </form>

    <vue-recaptcha
      sitekey="6Ld4mLAaAAAAAICmsap4Cq_uuCSy1Gmu8zMmWS0p"
      :loadRecaptchaScript="true"
      @verify="unverified = false"
      @expired="unverified = true"
    >
    </vue-recaptcha>

    <v-layout class="d-flex align-center action-button-spacing">
      <v-btn
        large
        class="white--text float-left"
        color="green"
        :disabled="unverified || cart_empty || $v.$invalid"
        @click="getQuote"
      >
        Get your Quote!
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn icon x-large color="primary" @click="click_like">
        <v-icon>mdi-thumb-up-outline</v-icon>
      </v-btn>
      <div v-if="likes !== null">{{ likes }} liked this page</div>
    </v-layout>
  </v-card>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, maxLength, email } from "vuelidate/lib/validators";
import VueRecaptcha from "vue-recaptcha";
import { configCollection } from "@/firebase";
import firebase from "firebase/app";
export default {
  name: "Cart",
  components: {
    VueRecaptcha,
  },
  mixins: [validationMixin],
  validations: {
    name: { required, maxLength: maxLength(100) },
    email: { required, email },
  },
  data() {
    return {
      name: this.$store.getters.getCustomer.name,
      email: this.$store.getters.getCustomer.email,
      headers: [
        { text: "", value: "image" },
        { text: "Model", value: "title" },
        { text: "Quantity", value: "quantity" },
        { text: "", value: "delete" },
      ],
      likes: null,
      liked: false,
      unverified: true,
    };
  },
  created() {
    configCollection
      .doc("counters")
      .get()
      .then((res) => {
        this.likes = res.data().likes;
      });
  },
  methods: {
    remove_item(item) {
      console.log(item);
      console.log(this.cart_items.indexOf(item));
      this.$store.commit("remove_cart_item", item);
    },
    click_like() {
      if (!this.liked) {
        configCollection
          .doc("counters")
          .update({
            likes: firebase.firestore.FieldValue.increment(1),
          })
          .then(() => {
            this.likes += 1;
            this.liked = true;
          });
      }
    },
    getQuote() {
      this.$store.commit("set_customer", {
        name: this.name,
        email: this.email,
      });
      this.$emit("get-quote");
    },
  },
  computed: {
    cart_items() {
      return this.$store.getters.getCart;
    },
    cart_empty() {
      return this.cart_items.length === 0;
    },
    nameErrors() {
      const errors = [];
      if (!this.$v.name.$dirty) return errors;
      !this.$v.name.maxLength &&
        errors.push("Name must be at most 100 characters long");
      !this.$v.name.required && errors.push("Name is required.");
      return errors;
    },
    emailErrors() {
      const errors = [];
      if (!this.$v.email.$dirty) return errors;
      !this.$v.email.email && errors.push("Must be valid e-mail");
      !this.$v.email.required && errors.push("E-mail is required");
      return errors;
    },
  },
};
</script>

<style scoped>
.action-button-spacing {
  margin: 20px;
}
</style>
